import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Logo from "./swedbankMynt.png";
import { MaxWidthWrapper, Headings } from "folksam-ui";
import ViewportPadding from "components/ViewportPadding";
import { useTranslation } from "react-i18next";
import Tooltip from "./Tooltip";

const headerStyles = ({ theme }) => {
  return {
    root: {
      backgroundColor: theme.colors.primary5,
      minHeight: 85
    },
    gradient: {
      height: 8,
      background: "linear-gradient(90deg, #FA7F25 0%, #FDBE13 100%)"
    },
    logoText: {
      fontSize: theme.textSizes.sm,
      fontFamily: theme.fonts.sans,
      color: theme.colors.senary2,
      borderLeft: `1px solid ${theme.colors.senary3}`,
      paddingLeft: theme.padding.md
    },
    inner: {
      // display: "flex",
      alignItems: "center",
      padding: "12px 0 12px 0"
    },
    logoWrapper: {
      // flexGrow: 1,
      display: "flex",
      justifyContent: "flex-end"
      // marginRight: theme.margin.lg
    },
    logo: {
      height: 52,
      width: 52
    },
    "@media (max-width: 1260px)": {
      logoWrapper: {
        marginRight: theme.margin.lg
      }
    },
    "@media (max-width: 600px)": {
      logoWrapper: {
        marginRight: 0,
        justifyContent: "center"
      }
    }
  };
};

const Header = injectSheet(headerStyles)(({ classes }) => {
  return (
    <div className={classes.root}>
      <div className={classes.gradient} />
      <MaxWidthWrapper>
        <div className={classes.inner}>
          <div className={classes.logoWrapper}>
            <img src={Logo} className={classes.logo} alt="Swedbank logo" />
          </div>
          {/* <div className={classes.logoText}>
              <div>Försäkringar från Swedbank och Sparbankerna</div>
              <div>Försäkringsgivare Tre Kronor Försäkring AB</div>
            </div> */}
        </div>
      </MaxWidthWrapper>
    </div>
  );
});

/**
 * Grey Banner
 */

const bannerStyles = ({ theme }) => {
  return {
    root: {
      backgroundColor: theme.colors.white,
      minHeight: 120,
      boxSizing: "border-box",
      padding: [theme.padding.sm, 0]
    },
    intro: {
      fontFamily: theme.fonts.swedbankSans,
      fontWeight: theme.fontWeights.medium,
      color: theme.colors.tertiary1,
      fontSize: "16px"
    },
    disclaimer: {
      fontFamily: theme.fonts.swedbankSans,
      fontWeight: theme.fontWeights.medium,
      color: theme.colors.tertiary1,
      margin: [0, 8, 0, 0],
      fontSize: "14px"
    },
    heading: {
      fontFamily: theme.fonts.swedbankHeadline,
      color: theme.colors.primary2,
      fontSize: "32px",
      fontWeight: 900
    },
    toolTipHeader: {
      fontFamily: theme.fonts.swedbankHeadline,
      color: "#f35b1c"
    },
    toolTipParagraph: {
      fontFamily: theme.fonts.sans,
      color: "#512b2b"
    }
  };
};

const Banner = ({ classes, title, intro, isSubmitted }) => {
  const { t } = useTranslation();

  return (
    <>
      {isSubmitted ? (
        <Header />
      ) : (
        <div>
          <Header />
          <div className={classes.root}>
            <MaxWidthWrapper>
              <ViewportPadding>
                <Headings.H1 className={classes.heading}>{title}</Headings.H1>
                {/* <p className={classes.intro}>{intro}</p> */}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",

                    boxSizing: "border-box"
                  }}
                >
                  <div
                    style={{
                      padding: "0px",
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center"
                    }}
                  >
                    <p className={classes.disclaimer}>
                      {t("banner.tooltip.text")}
                    </p>
                    <Tooltip symbol={"?"} direction={Tooltip.right}>
                      <strong className={classes.toolTipHeader}>
                        {t("banner.tooltip.header")}
                      </strong>
                      <br />
                      <p className={classes.toolTipParagraph}>
                        {t("banner.tooltip.paragraph")}
                      </p>
                    </Tooltip>
                  </div>
                </div>
              </ViewportPadding>
            </MaxWidthWrapper>
          </div>
        </div>
      )}
    </>
  );
};
Banner.propTypes = {
  title: PropTypes.string.isRequired
};

export default injectSheet(bannerStyles)(Banner);
